// import html2canvas from "html2canvas";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { secureAxios } from "../../_helper/constant/auth";
// import jsPDF from "jspdf";

export const getInvoiceNo = async (
  prefix,
  incremental_number,
  start_number
) => {
  const query = `?fields=invoice_no&sort=-date_created&limit=1`;
  try {
    const response = await secureAxios.get(
      `items/${ApiEndPoint.BILLING_CREDIT_INVOICE}${query}`
    );

    if (
      response.data?.length > 0 &&
      response?.data[0]?.invoice_no?.length > 0
    ) {
      let invoiceNo = Number(response?.data[0]?.invoice_no.replace(/\D/g, ""));
      invoiceNo += Number(incremental_number);
      return `${prefix}${invoiceNo}`;
    } else {
      const invoiceNo = Number(start_number);
      return `${prefix}${invoiceNo}`;
    }
  } catch (err) {
    console.log(err);
  }
};

export const getFormatedAddress = (address) => {
  if (address) {
    const { building_name, street_address, city, pincode } = address;
    return `${building_name}, ${street_address}, ${city}, ${pincode}`;
  }
};

// export function calculateDiscountedPrice(totalAmount, discount, type) {
//   if (type === "percentage") {
//     const discountAmount = (totalAmount * discount) / 100;
//     return totalAmount - discountAmount;
//   } else if (type === "amount") {
//     return totalAmount - discount;
//   } else {
//     alert("Invalid discount type. Valid types are 'percentage' or 'amount'.");
//   }
// }

export function calculateDiscountedPrice(totalAmount, discount, type) {
  let discountedPrice;

  if (type === "percentage") {
    const discountAmount = (totalAmount * discount) / 100;
    discountedPrice = totalAmount - discountAmount;
  } else if (type === "amount") {
    discountedPrice = totalAmount - discount;
  } else {
    alert("Invalid discount type. Valid types are 'percentage' or 'amount'.");
    return;
  }

  // Ensure the result is rounded to two decimal places
  return parseFloat(discountedPrice.toFixed(2));
}

export const validateDiscAmt = (totalAmount, discount, type) => {
  if (type === "percentage") {
    if (discount < 0 || discount > 100) {
      return false;
    }
  } else if (type === "amount") {
    if (discount < 0 || discount > totalAmount) {
      return false;
    }
  }
  return true;
};

export const filterLineData = (lineData, pkgs, services) => {
  // console.log(lineData, pkgs, services, 'sdksdja')
  const invoice_packages = [];
  const invoice_services = [];
  lineData?.forEach((dta) => {
    const [id, type] = dta?.description?.split("_");
    if (type === "pkg") {
      const alreadyExist = pkgs?.findIndex(
        (pkg) => pkg?.clinic_packages_id?.id === Number(id)
      );
      if (alreadyExist > -1) {
        invoice_packages.push({
          clinic_packages_id: Number(id),
          id: pkgs[alreadyExist]?.id,
        });
      } else {
        invoice_packages.push({ clinic_packages_id: Number(id) });
      }
    } else {
      const alreadyExist = services?.findIndex(
        (src) => src?.clinic_services_id?.id === Number(id)
      );
      if (alreadyExist > -1) {
        invoice_services.push({
          clinic_services_id: Number(id),
          id: services[alreadyExist]?.id,
        });
      } else {
        invoice_services.push({ clinic_services_id: Number(id) });
      }
    }
  });
  return { invoice_packages, invoice_services };
};

export const getPaymentPayload = (payments) => {
  const modifiedPayments = payments?.map((payment) => {
    return {
      status: payment?.status,
      recieved_payment: Number(payment?.amount),
      payment_mode: payment?.type,
      transaction_details: payment?.description,
      transaction_date: payment?.date,
    };
  });
  return modifiedPayments;
};
